'use strict'

import 'jquery'

let previous_meta_title = document.querySelector('title').textContent;
let previous_meta_description = document.querySelector('meta[name="description"]').getAttribute('content');

window.updateMeta = (is_previous = false, meta_title = '', meta_description = '', is_set_previous = true) => {
    if(is_previous) {
        if (previous_meta_title) {
            document.querySelector('title').textContent = previous_meta_title
            document.querySelector('meta[name="title"]').setAttribute('content', previous_meta_title)
            document.querySelector('meta[property="og:title"]').setAttribute('content', previous_meta_title)
        }
        if (previous_meta_description) {
            document.querySelector('meta[name="description"]').setAttribute('content', previous_meta_description);
            document.querySelector('meta[property="og:description"]').setAttribute('content', previous_meta_description);
        }
        return;
    }

    if (meta_description) {
        if(is_set_previous) {
            previous_meta_description = meta_description;
        }
        document.querySelector('meta[name="description"]').setAttribute('content', meta_description);
        document.querySelector('meta[property="og:description"]').setAttribute('content', meta_description);
    }
    if (meta_title) {
        if(is_set_previous) {
            previous_meta_title = meta_title;
        }
        document.querySelector('title').textContent = meta_title
        document.querySelector('meta[name="title"]').setAttribute('content', meta_title)
        document.querySelector('meta[property="og:title"]').setAttribute('content', meta_title)
    }
}

window.onload = () => {
    previous_meta_title = document.querySelector('title').textContent;
    previous_meta_description = document.querySelector('meta[name="description"]').getAttribute('content');
}


require('./setup')
require('./scroll-smoother')
require('./nav')


require('./blocks/index-hero')
require('./blocks/symbol-video')
require('./blocks/logos')
require('./blocks/our-expierence')
require('./blocks/client-reviews')
require('./blocks/services')
require('./blocks/scroll-gallery')
require('./blocks/dynamic-pinned-slide')
require('./blocks/history')
require('./blocks/heroes-stories')
require('./blocks/header-image-content')
require('./blocks/news')
require('./blocks/cookie-modal')
require('./blocks/intro')
require('./blocks/history-heroes')
require('./blocks/calculator')
require('./blocks/vacancies')

require('./components/services-slider')
require('./components/our-team')
require('./components/vacancies-list')

require('./parts/slider/horizontal-pinned-scroll')
require('./parts/slider/basic-carousel')
require('./parts/slider/image-with-text-slider')
require('./parts/slider/square-blocks-swiper')
require('./parts/accordion')

require('./modals/video')
require('./modals/image')

require('./theme-assets')

require('./elements/button')
require('./elements/form')
//require('./elements/follow-arrows')

require('./animations/text-scroll')
require('./animations/add-class-when-in-screen')
require('./animations/animate-divider')
require('./animations/shake-x')

require('./modals/timeline-image-modal')
require('./modals/timeline-block-modal')
require('./modals/services-modals')

require('./calculators/main.js')
require('./modals/vacancies-modals')
